import p from 'x/config/platform-specific'

const DonutChart = p.comp.getDonutChart()

export default DonutChart
